import PasswordRecoveryModule from './containers/passwordRecoveryModule'

export {default as PasswordRecoveryModuleLayout} from './components/passwordRecoveryModuleLayout'

export default PasswordRecoveryModule
